/* "Preview a day" for Little surprises (owner request 2026-10-31), the pure part. The owner (role owner only: never an
   admin, the bookkeeper or a member) picks a date in the 7-tap card; until he taps Stop, or his own real day ends
   (midnight in his own zone), the Little surprises (holidays, effects, Advent, the egg hunt, the Christmas Eve sleigh)
   see that date with the real time of day. NOTHING ELSE reads it: time entries, timers, the Today / Week totals,
   Reports, sync and everything saved keep the real clock (only src/surprises.ts and src/eggs.ts use this file; a unit
   test checks that). Saved on this device only. No screen, no storage here: tested in tests/app/surprises.test.ts. */

/** what is saved on the device: the date to show, the owner's real day it was set on, and who set it */
export interface Preview { date: string; setOn: string; by: string }
export const PREVIEW_KEY = 'ot_sx_preview';
/** found eggs / opened Advent doors during a preview are kept under this prefix (never the real ones); cleared on Stop */
export const PREVIEW_STORE = 'ot_sxprev_';
export const PREVIEW_MIN = '2020-01-01', PREVIEW_MAX = '2099-12-31';

const DATE = /^\d{4}-\d{2}-\d{2}$/;
/** a real calendar date 'YYYY-MM-DD' (no Feb 30) within the years the picker offers */
export function validDate(d: unknown): d is string {
  if (typeof d !== 'string' || !DATE.test(d) || d < PREVIEW_MIN || d > PREVIEW_MAX) return false;
  const t = new Date(Date.UTC(+d.slice(0, 4), +d.slice(5, 7) - 1, +d.slice(8, 10)));
  return t.getUTCFullYear() === +d.slice(0, 4) && t.getUTCMonth() + 1 === +d.slice(5, 7) && t.getUTCDate() === +d.slice(8, 10);
}
/** what a stored value says (anything odd: no preview) */
export function parsePreview(raw: string | null): Preview | null {
  try {
    const v = JSON.parse(raw || 'null');
    return v && validDate(v.date) && typeof v.setOn === 'string' && DATE.test(v.setOn) && typeof v.by === 'string' && v.by ? {date: v.date, setOn: v.setOn, by: v.by} : null;
  } catch { return null; }
}
/** is this preview on now? Only for the owner who set it, and only on the real day he set it (his own zone): at his
    midnight it ends by itself. realDate = his real day now 'YYYY-MM-DD'. */
export const previewOn = (p: Preview | null, role: string | null | undefined, meId: string | null | undefined, realDate: string): boolean =>
  !!p && role === 'owner' && !!meId && p.by === meId && p.setOn === realDate;
/** the moment the Little surprises see: the previewed date with the real time of day (wall = 'YYYY-MM-DDTHH:MM:SS') */
export const previewWall = (realWall: string, date: string | null) => date && validDate(date) ? date + realWall.slice(10) : realWall;

const WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/** 'Fri Mar 26, 2027' */
export function previewLabel(date: string): string {
  if (!validDate(date)) return '';
  const t = new Date(Date.UTC(+date.slice(0, 4), +date.slice(5, 7) - 1, +date.slice(8, 10)));
  return `${WD[t.getUTCDay()]} ${MO[t.getUTCMonth()]} ${t.getUTCDate()}, ${t.getUTCFullYear()}`;
}
